// select ShadowDOM impl
if (Platform.flags.shadow) {
